<template>
  <div>
    <SubcategoryFilters
      :name.sync="payload.name"
      :productCategoryId.sync="payload.productCategoryId"
      :productSubcategoryTypeId.sync="payload.productSubcategoryTypeId"
      @apply="getSubcategories(payload)"
    />
    <loading v-show="loading" />
    <v-card v-show="!loading" elevation="4">
      <v-app-bar flat dense elevation="0" color="transparent">
        <v-toolbar-title> <h4>Subcategories</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <template>
          <v-data-table
            :headers="headers"
            :items="subcategories"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :page.sync="pagination.page"
            :options.sync="pagination"
            :items-per-page.sync="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            @click:row="edit($event.id)"
            class="elevation-0"
          >
            <template v-slot:header.data-table-select="{ props, on }">
              <!-- COLOR Not working when props.indeterminate is true -->
              <v-simple-checkbox
                color="primary"
                v-ripple
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox
                color="primary"
                v-ripple
                :value="isSelected"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.action="{ item }">
              <v-menu offset-y bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon class="gray--text">more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item link>
                    <v-list-item-title @click="edit(item.id)"
                      >Edit</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item link>
                    <v-list-item-title @click="deleteAndRefresh(item.id)"
                      >Delete</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <template v-slot:item.amount="{ item }">
              {{ parseInt(item.amount, 10).toFixed(2) }}
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Helpers from "@/mixins/helpers";
import SubcategoryFilters from "./SubcategoryFilters.vue";
export default {
  components: {
    SubcategoryFilters
  },
  mixins: [Helpers],
  props: {
    payload: {
      type: Object,
      default: () => {
        return {
          from: 0,
          to: 10,
          name: null,
          productCategoryId: null,
          productSubcategoryTypeId: null
        };
      }
    },
    module: {
      type: String,
      default: "subcategories/LOAD_SUBCATEGORIES"
    },
    actions: {
      type: Boolean,
      default: true
    }
  },
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Description",
          align: "left",
          sortable: false,
          value: "description"
        },
        {
          text: "Category",
          align: "left",
          sortable: false,
          value: "category.name"
        },
        {
          text: "Type",
          align: "left",
          sortable: false,
          value: "productSubCategoryType.name"
        },
        { text: "", value: "action", align: "right" }
      ]
    };
  },
  computed: {
    subcategories() {
      return this.$store.state.subcategories.subcategories;
    },
    totalItems() {
      return this.$store.state.subcategories.totalSubcategories;
    }
  },
  created() {
    this.getSubcategories(this.payload);
    if (this.actions == false) {
      this.headers = this.headers.filter(column => column.value !== "action");
    }
  },
  methods: {
    async getSubcategories(payload) {
      this.loading = true;
      await this.$store.dispatch(this.module, payload);
      this.loading = false;
    },
    updatePagination(pagination) {
      let payload = this.payload;
      (payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage),
        (payload.to =
          pagination.itemsPerPage === -1
            ? this.totalItems
            : pagination.itemsPerPage);
      this.getSubcategories(payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        let payload = this.payload;
        (payload.from =
          pagination.page * pagination.itemsPerPage - pagination.itemsPerPage),
          (payload.to =
            pagination.itemsPerPage === -1
              ? this.totalItems
              : pagination.itemsPerPage);
        this.getSubcategories(payload);
      }
    }
  }
};
</script>
